import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import TradeHelpLogo from '../../img/tradehelp-logo.png';
import OfficeIcon from '../../img/office-icon.png';
import AppStoreButton from '../../img/app-store.png';
import GooglePlayButton from '../../img/google-play.png';
import CreateUserService from '../../Services/CreateUserService';
import Rocket from '../../img/rocket.png';

const DynamicThankyou = () => {
	const [linkEmailed, setLinkEmailed] = useState(false);
	const [officeLink, setOfficeLink] = useState('https://office.tradehelp.co.uk/Account/Login');
	const emailMeLink = () => {
		CreateUserService.sendEmailLink().then((response) => {
			setLinkEmailed(response.data);
		});
	};

	useEffect(() => {
		CreateUserService.getOfficeLink().then((response) => {
			setOfficeLink(response.data.officeLink);
		});
	}, []);

	return (
		<div className='signupFormStyles'>
			<div className='dynamicThankyouPage'>
				<div className='container-fluid logoHeader'>
					<div className='container text-center'>
						<img src={TradeHelpLogo} alt='' />
					</div>
				</div>

				<div className='text-center pt-5 container px-0 content-wrapper'>
					<div className='px-4 top-section-content'>
						<h3 className='dynamic-heading mb-4'>Congratulations! You&apos;re all set...</h3>

						<p>
							A member of the team will be in touch shortly to discuss the benefits available and get you up and
							running!
						</p>

						<p>In the meantime, on your mobile device, download the TradeHelp app from the links below.</p>

						<p>
							{' '}
							Once downloaded, select &apos;Sign In&apos; and use the password and email address you have just provided
							to access your account.
						</p>

						<p>
							If you have any questions you can call us on{' '}
							<a type='tel' href='01978 666 887'>
								01978 666 887
							</a>{' '}
							or email{' '}
							<a type='mail' href='info@tradehelp.co.uk'>
								info@tradehelp.co.uk
							</a>
							.
						</p>

						<div className='d-flex justify-content-center mt-5'>
							<a
								href='https://play.google.com/store/apps/details?id=com.TradeHelp.Mobile&hl=en_GB'
								target='_blank'
								rel='noreferrer'>
								<img className='appButton me-4' src={GooglePlayButton} alt='' />
							</a>

							<a href='https://apps.apple.com/gb/app/tradehelp-app/id1266213426' target='_blank' rel='noreferrer'>
								<img className='appButton' src={AppStoreButton} alt='' />
							</a>
						</div>

						<img className='rocket-image' src={Rocket} alt='Rocket leaving phone' />
					</div>

					<div className='shadow-card'>
						<h3 className='dynamic-heading mb-4'>Start saving today...</h3>

						<p>
							You are now entitled to cash back from 12 leading manufacturers and discounts from our merchant partners
							including City Plumbing, Wolseley, James Hargreaves, B&Q TradePoint and Toolstation.
						</p>

						<a
							href='mailto:info@tradehelp.co.uk?subject=I%20wish%20to%20get%20set%20up%20for%20my%20manufacturer%20and%20merchant%20benefits%20with%20TradeHelp'
							className='btn btn-primary w-100 mt-4 pulse-grow-on-hover dynamic-bgColour d-flex align-items-center justify-content-center'>
							Click here to get set up at no cost
						</a>

						<hr className='my-5' />

						<h3 className='dynamic-heading mb-4'>Free Instant Parts Finder</h3>

						<p>
							To access a free instant parts finder on BuyTrade, and view local product availability, click below and
							log in using your existing TradeHelp credentials.
						</p>

						<a
							href='https://www.buytrade.co.uk'
							className='btn btn-primary w-100 mt-4 pulse-grow-on-hover dynamic-bgColour d-flex align-items-center justify-content-center'
							target='_blank'
							rel='noreferrer'>
							Go to BuyTrade
						</a>
					</div>
				</div>

				<div className='dark-section'>
					<div className='content-wrapper mx-auto text-white'>
						<div className='dark-section-content'>
							<img src={OfficeIcon} className='officeIcon' alt='' />

							<h3 className='dynamic-heading mb-4'>Log into TradeHelp Office on Desktop</h3>

							<p>You can also access your account via your laptop or PC.</p>

							<p>
								Log in via the TradeHelp website or go to{' '}
								<a href='https://office.tradehelp.co.uk' target='_blank' rel='noreferrer'>
									office.tradehelp.co.uk
								</a>{' '}
								using the same password and email address to access your account.
							</p>

							{linkEmailed === true ? (
								<div className='d-flex align-items-center justify-content-center mt-4 emailSentAlert'>
									<div>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='16'
											height='16'
											fill='currentColor'
											class='bi bi-check-circle-fill me-2'
											viewBox='0 0 16 16'>
											<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z' />
										</svg>
									</div>

									<p>Email sent</p>
								</div>
							) : (
								<button
									onClick={emailMeLink}
									className='btn btn-primary w-100 mt-4 pulse-grow-on-hover dynamic-bgColour'>
									Email me the link
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DynamicThankyou;
